import React, { useRef } from 'react'
import Skeleton from 'react-loading-skeleton'

const Index = () => {
    const refs = useRef()
    return (
        <div className="list-loader-container">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding pb-0">
                        <div className="card border-0 shadow-sm">
                            <div className="card-body p-xl-4">
                                <div className="d-lg-flex">
                                    <div className="text-center">
                                        <Skeleton width={160} height={160} circle={true} />
                                    </div>
                                    <div className="flex-fill px-2 py-2 py-lg-0 mt-3 mt-lg-0 pl-lg-4" ref={refs}>
                                        <Skeleton height={160} width={refs.innerWidth} />
                                    </div>
                                    <div className="flex-fill px-2" ref={refs}>
                                        <Skeleton height={160} width={refs.innerWidth} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    {[...Array(4).keys()].map((i) => {
                                        return (
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={i} ref={refs}>
                                                <div className="mb-4">
                                                    <Skeleton height={5} width={refs.innerWidth} />
                                                    <Skeleton height={5} width={220} />
                                                    <Skeleton height={5} width={refs.innerWidth} />
                                                    <Skeleton height={5} width={220} />
                                                </div>
                                                <div className="mb-4">
                                                    <Skeleton height={5} width={refs.innerWidth} />
                                                    <Skeleton height={5} width={220} />
                                                    <Skeleton height={5} width={refs.innerWidth} />
                                                    <Skeleton height={5} width={220} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Index;